import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'servicePipe'})
export class ServicePipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if(!items) return [];
    if(!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter( item => {
      return (item.id.toString().toLowerCase().includes(searchText)
        || item.client_name.toLowerCase().includes(searchText)
        || item.client_alias.toLowerCase().includes(searchText)
        || item.building_name.toLowerCase().includes(searchText)
        || item.service_type.toLowerCase().includes(searchText)
        || item.discipline.toLowerCase().includes(searchText)
        || item.subject.toLowerCase().includes(searchText)
        || item.problem.toLowerCase().includes(searchText)
        || item.status.toLowerCase().includes(searchText));
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/service.pipe.ts